// Function to modify the element once it's found
function modifyRecommendsValue(element) {
    // Get the text content (e.g. "88%")
    const text = element.textContent.trim();

    // Split the number from the percent symbol
    const numberPart = text.replace("%", "");

    // Clear the current content
    element.innerHTML = "";

    // Create span for the number part
    const numberSpan = document.createElement("span");
    numberSpan.textContent = numberPart;
    numberSpan.style.cssText = `
      font-family: 'ModernGothic-Light', sans-serif !important;
      font-weight: 300 !important;
      letter-spacing: -1px !important;
    `;

    // Create span for the percent symbol
    const percentSpan = document.createElement("span");
    percentSpan.textContent = "%";
    percentSpan.style.cssText = `
      font-family: 'ModernGothic-Light', sans-serif !important;
      font-weight: 300 !important;
      font-variant: tabular-nums !important;
      letter-spacing: -1px !important;
    `;

    // Append both spans to the element
    element.appendChild(numberSpan);
    element.appendChild(percentSpan);
    const recommendsText = document.querySelector(
        ".oke-w-recommendsModule-text"
    );

    // Check if the element exists and contains the word 'products'
    if (recommendsText && recommendsText.textContent.includes(" products")) {
        // Replace ' products' (with the space) with an empty string
        recommendsText.textContent = recommendsText.textContent.replace(
            " products",
            ""
        );
    }
}

// Function to check if the element exists and apply modifications
function checkForElement() {
    const element = document.querySelector(".oke-w-recommendsModule-value");

    if (element) {
        modifyRecommendsValue(element);
        return true;
    }

    return false;
}

// Try to find the element immediately
// if (!checkForElement()) {
// If not found, set up a MutationObserver to watch for DOM changes
// console.log("Element not found initially, watching for DOM changes...");

// const observer = new MutationObserver((mutations) => {
//     if (checkForElement()) {
//         // Once element is found and modified, disconnect the observer
//         observer.disconnect();
//     }
// });

// // Start observing the document body for DOM changes
// observer.observe(document.body, {
//     childList: true,
//     subtree: true,
// });

// As a fallback, also check every 500ms for the element
// This helps in case the element is added in a way the MutationObserver might miss
const intervalId = setInterval(() => {
    if (checkForElement()) {
        // clearInterval(intervalId);
        // console.log("checkForElement passed");
    }
}, 500);

// Stop checking after 30 seconds to avoid infinite polling
setTimeout(() => {
    // observer.disconnect();
    clearInterval(intervalId);
    // console.log("Stopped watching for element after 30 seconds");
}, 120000);
// }
